enum MigrationPageRouteEnum {
  Migration = '/migration',
  Organizations = '/migration-organizations',
  Report = '/migration-report',
  Congrats = '/migration-congrats'
}

export default MigrationPageRouteEnum;
